import { create, useStore } from "zustand";
import { persist } from "zustand/middleware";

type SessionState = {
  accessToken: string;
  addToken: (accessToken: string) => void;
  delToken: () => void;
};

const sessionStore = create<SessionState>()(
  persist(
    (set) => ({
      accessToken: "",
      addToken: (accessToken) => set({ accessToken }),
      delToken: () => set({ accessToken: "" }),
    }),
    {
      name: "session",
    },
  ),
);

export const useAuth = () =>
  useStore(sessionStore, (state) => !!state.accessToken);

export const getTokens = () => ({
  accessToken: sessionStore.getState().accessToken,
});

export const addToken = (accessToken: string) =>
  sessionStore.getState().addToken(accessToken);

export const delToken = () => sessionStore.getState().delToken();
